import React, { useState } from "react";
import styled from "styled-components";
import CheckedSvg from "./CheckedSvg";
import NotCheckedSvg from "./NotCheckedSvg";

const CheckboxContainer = styled.div`
  flex: 1;
  margin-left: 0.5em;
  margim-right: 0.5em;
`;

const Label = styled.div(({ theme }) => ({
  fontSize: 16,
  color: theme.color.text,
  textAlign: "start",
  fontWeight: 300,
  marginInlineStart: 5,
  whiteSpace: "nowrap",
}));

const Checkbox = ({ width, height, checked, onChange, label, error, ...props }) => {
  const [isChecked, setCheched] = useState(checked);
  return (
    <CheckboxContainer
      style={{ ...props.style }}
      onClick={() => {
        setCheched(!checked);
        onChange();
      }}
    >
      <div
        style={{
          alignItems: "center",

          display: "flex",
          alignSelf: "center",
        }}
      >
        {isChecked ? (
          <CheckedSvg style={{ width: width, height: height }} />
        ) : (
          <NotCheckedSvg style={{ width: width, height: height }} />
        )}
        {!!label && <Label>{label}</Label>}
      </div>
    </CheckboxContainer>
  );
};

export default Checkbox;
